import { IMaskInput } from 'react-imask';
import { Box, Checkbox, Grid, InputBase, Text, TextInput } from '@mantine/core';

import InputLabel from 'components/InputLabel';
import SectionTitle from 'components/SectionTitle';
import { MARRIED } from 'constants/App';
import { IPageData } from '.';

const SpouseInformation = ({ form, isMobile, t }: IPageData) => {
  if (form.values.maritalStatus !== MARRIED) {
    return <></>;
  }
  
  return (
    <Box mt={48}>
      <SectionTitle title={t('section.information.spouse')} />
      <Grid columns={isMobile ? 1 : 12}>
        <Grid.Col span={isMobile ? 1 : 12}>
          <TextInput
            label={<InputLabel label={t('input.fullName.spouse.label')} />}
            key={form.key('spouseFullName')}
            {...form.getInputProps('spouseFullName')}
          />
          <Text size={'xs'} mt={8}>{t('input.fullName.description')}</Text>
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <InputBase
            label={<InputLabel label={t('input.phone.spouse.label')} />}
            component={IMaskInput}
            mask={t('input.phone.mask')}
            placeholder={t('input.phone.placeholder')}
            type={'tel'}
            onAccept={(value: string) => {
              if (value.startsWith('+41 0')) {
                form.setFieldValue('spousePhone', '+41 ');
              }
            }}
            key={form.key('spousePhone')}
            {...form.getInputProps('spousePhone')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <TextInput
            label={<InputLabel label={t('input.email.spouse.label')} />}
            placeholder={t('input.email.placeholder')}
            type={'email'}
            key={form.key('spouseEmail')}
            {...form.getInputProps('spouseEmail')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 12}>
          <Checkbox
            color={'#62AF45'}
            label={<InputLabel label={t('privacy.policy.spouse.accept')} />}
            key={form.key('spousePrivacyPolicy')}
            {...form.getInputProps('spousePrivacyPolicy')}
          />
        </Grid.Col>
      </Grid>
    </Box>
  )
}

export default SpouseInformation;